import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { ToastComponent } from './toast.component';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule,
  ],
  providers: [],
  declarations: [ToastComponent],
  exports: [ToastComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ToastModule { }
